import { UserInPing } from '@reach/interfaces/user/user-in-ping';

import { ClientSession } from '../session.type';

export function apiUserParser(user: UserInPing | null): ClientSession | null {
	if (!user) {
		return null;
	}

	return {
		userId: user.privateId,
		username: user.username,
		email: user.email,
		adminRole: user.adminFeatureFlags,
		featureFlags: user.userFeatureFlags || [],
		adminToolsFlags: user.adminToolsFlags || [],
		adminDashboardFlags: user.adminDashboardFlags || [],
		leader: user.leader ?? undefined,
	};
}
